/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/tender';
import '../../panhandler/service';
import '../../common/location';
import '../../merchants/api';
import '../../common/gateways';
import '../../common/merchant_type';
import '../../roster/mds';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "Tender": {
                "fields": {
                  "cardTender": {
                    "type": "squareup.common.tender.CardTender",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedTender": {
                    "type": "squareup.panhandler.service.ServerEncryptedTender",
                    "id": 4,
                    "rule": "optional"
                  },
                  "panFideliusToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Merchant": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "storeId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "terminalId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "name1": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "name2": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "name3": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "categoryCode": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "squareup.common.location.Phone",
                    "id": 8,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.location.Address",
                    "id": 9,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "squareup.merchants.api.UserLocale",
                    "id": 10,
                    "rule": "optional"
                  },
                  "transactionFund": {
                    "type": "squareup.merchants.api.TransactionFund",
                    "id": 11,
                    "rule": "optional"
                  },
                  "gatewayMerchantTokens": {
                    "type": "squareup.esperanto.api.Merchant.GatewayMerchantToken",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "businessType": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "gatewayHints": {
                    "type": "squareup.common.gateways.GatewayName",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "merchantType": {
                    "type": "squareup.common.MerchantType",
                    "id": 15,
                    "rule": "optional"
                  },
                  "permissions": {
                    "type": "squareup.esperanto.api.MerchantPermission",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "personalName": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "businessCategory": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "businessSubCategory": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "cashUserToken": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "parentMerchantToken": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "unitPaymentData": {
                    "type": "squareup.roster.mds.UnitPaymentData",
                    "id": 23,
                    "rule": "optional"
                  },
                  "platformHidden": {
                    "type": "bool",
                    "id": 25,
                    "rule": "optional"
                  },
                  "businessIds": {
                    "type": "squareup.roster.mds.BusinessIds",
                    "id": 26,
                    "rule": "optional"
                  },
                  "businessUnit": {
                    "type": "squareup.roster.mds.BusinessUnit",
                    "id": 27,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "GatewayMerchantToken": {
                    "fields": {
                      "gateway": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "MerchantPermission": {
                "values": {
                  "ACCEPT_PAYMENT_CARDS": 1,
                  "ACCEPT_PAYMENTS_ANYWHERE": 2,
                  "BACKGROUND_CAPTURE": 3,
                  "ACCEPT_DELEGATED_PAYMENTS": 4,
                  "HAVE_DELEGATE_ACCOUNTS": 5,
                  "SKIP_SIGNATURES_FOR_SMALL_PAYMENTS": 6,
                  "NOT_SELLER_ACCEPT_MERCHANT_BALANCE_PAYMENTS": 7,
                  "NOT_SEND_AUTOMATIC_RECEIPTS": 8,
                  "ACCEPT_HIGH_TRANSACTION_AMOUNTS": 9,
                  "USE_CARD_ASSOCIATED_COUPONS": 10,
                  "USE_GIFT_CARDS_V2": 11,
                  "OPT_OUT_OF_MCC_ALIAS_ON_SOFT_DESCRIPTOR": 12,
                  "ACCEPT_THIRD_PARTY_GIFT_CARDS": 13,
                  "DELEGATE_ACCOUNTS_MAKE_REFUNDS": 14,
                  "USE_ANY_PRODUCT_TYPE": 15,
                  "ACCEPT_O1_READER_TRANSACTIONS_IN_JAPAN": 16,
                  "ACCEPT_JPY_JCB_PAYMENT_CARDS": 17,
                  "ALLOW_PARTIAL_AUTH_FOR_NON_GIFTCARDS": 18,
                  "SKIP_CARD_EXPIRATION_CHECKS": 19,
                  "PERFORM_REFUNDS_WITH_UNLIMITED_POTENTIAL": 20,
                  "DECLINE_ALL_AUTHS": 21,
                  "FORCE_RECEIPT_EMAIL_ENTRY": 22,
                  "ACCEPT_ALL_TRANSACTION_AMOUNTS": 23
                }
              },
              "ProductSubcategory": {
                "values": {
                  "NONE": 0,
                  "CASH_P2P": 1,
                  "CASH_PAYROLL": 2,
                  "CASH_RAPID_SETTLEMENT": 3,
                  "CASH_CHECK_DISPLACEMENT": 4,
                  "CASH_PRO_PURCHASE": 5,
                  "CASH_REFERRAL": 6,
                  "CASH_ADD_CASH": 7,
                  "SQUARE_INSTANT_DEPOSIT": 8,
                  "SQUARE_PAYROLL": 9,
                  "CASH_CASH_OUT": 10,
                  "SQUARE_INSTANT_DEPOSIT_MICRO": 11,
                  "CASH_ADD_CASH_AA": 12,
                  "CASH_ADD_CASH_WT": 13,
                  "CASH_CASH_OUT_DELAYED": 14,
                  "CASH_ADD_CASH_FT": 15,
                  "CASH_APP_PAY": 16,
                  "CASH_ADD_CASH_FOR_CRYPTO": 17,
                  "CASH_ADD_CASH_FOR_STOCKS": 18,
                  "CASH_LOAN_REPAYMENT": 19
                }
              },
              "ProcessingCode": {
                "values": {
                  "USE_DEFAULT": 0,
                  "PROCESSING_CODE_20": 1,
                  "PROCESSING_CODE_56": 2
                }
              },
              "StoredCardPaymentData": {
                "fields": {
                  "networkSequenceIdentifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "settlementDateMmdd": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "networkInformation": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "transactionQualifier": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "originalAuthorizedAmount": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "PosSpecialConditionIndicator": {
                "values": {
                  "DEFAULT": 0,
                  "CRYPTOCURRENCY": 1,
                  "EXISTING_DEBT": 2
                }
              },
              "IssuerInstallmentDetails": {
                "fields": {
                  "type": {
                    "type": "squareup.esperanto.api.IssuerInstallmentDetails.IssuerInstallmentType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "installmentCount": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "IssuerInstallmentType": {
                    "values": {
                      "NO_INSTALLMENTS": 0,
                      "FIXED": 1,
                      "REVOLVING": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.Tender && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.Merchant && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.Merchant?.nested?.GatewayMerchantToken && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.MerchantPermission && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.ProductSubcategory && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.ProcessingCode && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.StoredCardPaymentData && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PosSpecialConditionIndicator && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.IssuerInstallmentDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.IssuerInstallmentDetails?.nested?.IssuerInstallmentType) {
  $root.addJSON(jsonData);
}

/**
 * Set of tenders. RPC endpoints that accept tender must have only one of them set.
 * Not all the options are valid for each individual RPC endpoint.
 *
 * SOURCE Tender @ squareup/esperanto/api/common.proto at 21:1
 */
export const Tender = $root.lookupType('squareup.esperanto.api.Tender');
fixType(Tender);
Builder.createAndAttachToType(Tender);
/**
 * RPC request merchant field. Note that these fields are not necessarily persisted.
 *
 * SOURCE Merchant @ squareup/esperanto/api/common.proto at 39:1
 */
export const Merchant = $root.lookupType('squareup.esperanto.api.Merchant');
fixType(Merchant);
Builder.createAndAttachToType(Merchant);
/**
 * SOURCE GatewayMerchantToken @ squareup/esperanto/api/common.proto at 40:3
 */
Merchant.GatewayMerchantToken = $root.lookupType('squareup.esperanto.api.Merchant.GatewayMerchantToken');
fixType(Merchant.GatewayMerchantToken);
Builder.createAndAttachToType(Merchant.GatewayMerchantToken);
/**
 * Permissions merchant can have.
 * e.g. Is the user able to take a card payment.
 *
 * SOURCE MerchantPermission @ squareup/esperanto/api/common.proto at 141:1
 */
export const MerchantPermission = $root.lookupEnum('squareup.esperanto.api.MerchantPermission').values;
/**
 * The specific subcategory of payment transaction for the originating Square product associated
 * with the transaction.
 *
 * NOTE: These cannot be renamed because they are used in external reporting.
 *
 * SOURCE ProductSubcategory @ squareup/esperanto/api/common.proto at 270:1
 */
export const ProductSubcategory = $root.lookupEnum('squareup.esperanto.api.ProductSubcategory').values;
/**
 * Processing code options that can be passed through to the gateway, e.g. Shazam can code
 * transactions differently depending on remote network. These may not be supported by all
 * remote gateways, so this is an optional field.
 *
 * SOURCE ProcessingCode @ squareup/esperanto/api/common.proto at 378:1
 */
export const ProcessingCode = $root.lookupEnum('squareup.esperanto.api.ProcessingCode').values;
/**
 * SOURCE StoredCardPaymentData @ squareup/esperanto/api/common.proto at 404:1
 */
export const StoredCardPaymentData = $root.lookupType('squareup.esperanto.api.StoredCardPaymentData');
fixType(StoredCardPaymentData);
Builder.createAndAttachToType(StoredCardPaymentData);
/**
 * SOURCE PosSpecialConditionIndicator @ squareup/esperanto/api/common.proto at 441:1
 */
export const PosSpecialConditionIndicator = $root.lookupEnum('squareup.esperanto.api.PosSpecialConditionIndicator').values;
/**
 * Details for payments that the issuer will bill to the cardholder in installments over time, as
 * requested by the cardholder. When applied, settlement still occurs to Square and the merchant
 * in full as a single payment. This option is only available in certain markets (Japan, as of
 * Jan. 2024).
 *
 * SOURCE IssuerInstallmentDetails @ squareup/esperanto/api/common.proto at 486:1
 */
export const IssuerInstallmentDetails = $root.lookupType('squareup.esperanto.api.IssuerInstallmentDetails');
fixType(IssuerInstallmentDetails);
Builder.createAndAttachToType(IssuerInstallmentDetails);
/**
 * SOURCE IssuerInstallmentType @ squareup/esperanto/api/common.proto at 487:3
 */
IssuerInstallmentDetails.IssuerInstallmentType = $root.lookupEnum('squareup.esperanto.api.IssuerInstallmentDetails.IssuerInstallmentType').values;